import FnFieldTitle from '../../../elements/FnFieldTitle';
import FnCheckbox from '../../../elements/FnCheckbox';
import React, { FC, memo } from 'react';
import { ActionMeta, GroupedOptionsType, ValueType } from 'react-select/src/types';
import Select, { components, OptionTypeBase } from 'react-select';
import { FnDropdownIndicator } from '../FnDropdownIndicator';
import {
  ControlStyles,
  DivWrapper,
  DropdownIndicatorStyled,
  HiddenStyles,
  InputStyles,
  MenuStyles,
  MultiValueStyles,
  PlaceholderStyles,
  ValueContainerStyles
} from '../styles';
import { GroupStyles, MenuListStylesNew, OptionStyled } from './styles';

const Group = (props) => <components.Group {...props} />;
const Option = (props) => {
  return (
    <components.Option {...props}>
      <div style={{ pointerEvents: 'none' }}>
        <FnCheckbox name={props.value} value={props.isSelected} label={props.label} />
      </div>
    </components.Option>
  );
};
const MultiValue = (props) => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);

type TProps = {
  value: OptionTypeBase[];
  options: GroupedOptionsType<object>[];
  onChange: (value: ValueType<OptionTypeBase, boolean>, actionMeta: ActionMeta<OptionTypeBase>) => void;
  placeholder?: string;
  title?: string;
  isRequired?: boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
  isInvalid?: boolean;
};

const FnGroupMultiSelect: FC<TProps> = ({
  value,
  options,
  hideSelectedOptions = false,
  closeMenuOnSelect = false,
  isRequired = false,
  onChange = null,
  title = '',
  placeholder = '',
  isInvalid = false
}) => {
  return (
    <DivWrapper isInvalid={Number(isInvalid)}>
      {title && <FnFieldTitle title={title} isRequired={isRequired} />}
      <Select
        placeholder={placeholder}
        options={options}
        onChange={(value, actionMeta) => onChange && onChange(value, actionMeta)}
        isMulti={true}
        hideSelectedOptions={hideSelectedOptions}
        closeMenuOnSelect={closeMenuOnSelect}
        value={value}
        components={{ DropdownIndicator: FnDropdownIndicator, Option, MultiValue, Group }}
        styles={{
          menuList: MenuListStylesNew,
          group: GroupStyles,
          option: OptionStyled,
          placeholder: PlaceholderStyles,
          clearIndicator: HiddenStyles,
          indicatorSeparator: HiddenStyles,
          control: ControlStyles,
          valueContainer: ValueContainerStyles,
          menu: MenuStyles,
          input: InputStyles,
          multiValue: MultiValueStyles,
          dropdownIndicator: DropdownIndicatorStyled
        }}
      />
    </DivWrapper>
  );
};

export default memo(FnGroupMultiSelect);
